export default theme => ({

  root: {
    paddingLeft: theme.spacing.unit * 1.35,
    paddingRight: theme.spacing.unit * 5,
    transition: 'background-color 0.1s ease-in'
  },

  hovered: {
    background: theme.qborder.background.hover
  },

  flashed: {
    background: `${theme.qborder.background.flash} !important`,
    transition: 'background-color 0.25s ease-in-out'
  },

  icon: {
    marginRight: 0,
    position: 'relative',
    left: '-3px'
  },

  '@media (min-width: 600px)': {

    root: {
      paddingLeft: theme.spacing.unit * 3.5,
    }

  }

});




// WEBPACK FOOTER //
// ./src/styles/components/TreeNode.js